module.exports = __webpack_public_path__ + "static/media/truck-red.d57cc073.svg";